import Menu, { MenuProps } from '@mui/material/Menu';

interface MenuWrapperProps extends MenuProps {
  width?: number;
}

export const MenuWrapper = ({
  slotProps,
  width,
  ...props
}: MenuWrapperProps) => {
  return (
    <Menu
      slotProps={{
        ...slotProps,
        list: {
          disablePadding: true,
          sx: { width },
          ...slotProps?.list,
        },
      }}
      {...props}
    />
  );
};
